export default class Pagination {
	currentPage: number;

	perPage: number;

	total: number;

	totalPages: number;

	constructor(currentPage: number, perPage: number, total: number, totalPages: number) {
		this.currentPage = currentPage;
		this.perPage = perPage;
		this.total = total;
		this.totalPages = totalPages;
	}

	static empty(params: { currentPage?: number; perPage?: number; total?: number; totalPages?: number } = {}) {
		return new Pagination(params.currentPage || 0, params.perPage || 0, params.total || 0, params.totalPages || 0);
	}

	getFirstIndex(): number {
		return (this.currentPage - 1) * this.perPage;
	}

	getNextPage(): number | null {
		return this.hasNextPage() ? this.currentPage + 1 : null;
	}

	hasNextPage(): boolean {
		return this.currentPage < this.totalPages;
	}

	get nextGrowedPage(): { number: number; perPage: number } | null {
		const nextPage = this.getNextPage();
		if (nextPage === null) {
			return null;
		}

		const perPage = Math.min(1600, (nextPage - 1) * this.perPage);
		return {
			number: perPage === this.perPage ? nextPage : Math.min(2, nextPage),
			perPage,
		};
	}
}
